import {Col, DatePicker} from 'antd';
import dayjs from 'dayjs';
import {useFormikContext} from 'formik';
import React from 'react';
import {useSelector} from 'react-redux';
import {DATE_TIME_LOCALE} from 'Utils/constants/DateFormat';
import FieldError from '../FieldError';
import FieldLabel from '../FieldLabel';
import {getDisabledDate, toDayjsFormat} from '../dateHelpers';
import {fieldColProps} from '../gridHelpers';

export default function CustomDateTimePicker(props) {
  const textField = props.field;
  const {setFieldValue, setFieldTouched, values, touched, errors} = useFormikContext<any>();
  const tenantConfig = useSelector((state: any) => state?.login?.tenantConfig);
  const inputDateFormat = DATE_TIME_LOCALE[tenantConfig?.locale];
  // Same display pattern as before (e.g. dd/MM/yyyy HH:mm) — only translated to
  // dayjs tokens so antd renders/parses the year correctly.
  const format = toDayjsFormat(textField?.dateFormat || inputDateFormat);
  const hasError = Boolean(touched[textField?.name] && errors[textField?.name]);

  const commitValue = (value) => {
    const next = value ? value.toDate() : null;
    const current = values[textField?.name];
    const unchanged = next === current || (next && current && +new Date(current) === +next);
    if (!unchanged) setFieldValue(textField.name, next);
    setFieldTouched(textField.name, true, false);
  };

  return (
    <Col {...fieldColProps(textField)}>
      <FieldLabel field={textField} />
      <DatePicker
        showTime
        // Commit the picked date/time straight away instead of only on "OK",
        // so clicking outside the panel doesn't silently discard the selection.
        needConfirm={false}
        format={format}
        style={{width: '100%'}}
        status={hasError ? 'error' : undefined}
        disabled={textField?.isDisabled ?? false}
        disabledDate={getDisabledDate(textField)}
        value={values[textField?.name] ? dayjs(values[textField?.name]) : null}
        onChange={(value) => commitValue(value)}
        // antd's picker skips onChange when the new pick has the same day and
        // month as the old one but a different year (e.g. 28/09/2027 → 28/09/2026),
        // so the input shows the new date while the form keeps the old year.
        // onCalendarChange fires for every panel pick, so commit from there too.
        onCalendarChange={(value) => commitValue(Array.isArray(value) ? value[0] : value)}
      />
      <FieldError name={textField?.name} />
    </Col>
  );
}
